<template>
  <div>
    <a-modal v-model="visible" class="changelog-modal" width="960px" centered :footer="null" @cancel="closed">
      <span slot="title" class="changelog-header">
        <span class="version">{{ changelog.version }}</span>
        <span class="title">{{ changelog.title }}</span>
        <span class="release-time">{{ changelog.release_time }}</span>
      </span>
      <div class="changelog-modal-content">
        <div v-if="changelog.images" class="changelog-images">
          <image-carousel :images="changelog.images" />
        </div>
        <div class="changelog-content">
          <vditor-preview :content="changelog.content" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import VditorPreview from '@/components/VditorEditor/preview';
import ImageCarousel from '@/components/ImageCarousel';
import { changelogDetail, changelogRead } from '@/api/system/about';
export default {
  name: 'ChangelogModal',
  components: { VditorPreview, ImageCarousel },
  props: {
    changelogId: {
      type: [Number, String],
      default: null
    },
    changelogData: {
      type: Object,
      default: null
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      changelog: {
        images: [],
        verison: '',
        content: ''
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.changelog = {
          verison: ''
        };
        if (this.changelogId) {
          this.getDetail();
        } else {
          this.changelog = this.changelogData;
        }
      }
    }
  },
  methods: {
    closed() {
      if (this.changelogId === null) {
        this.setChangelogRead();
      }
      this.$emit('cancel');
    },

    // 获取日志详情
    getDetail() {
      changelogDetail({ changelog_id: this.changelogId }).then(res => {
        this.changelog = res.data;
      });
    },

    setChangelogRead() {
      changelogRead({ changelog_id: this.changelog.id }).then(() => {
        this.$emit('close');
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.ant-carousel .slick-slide {
  text-align: center;
  height: 320px;
  overflow: hidden;
}

/deep/.ant-modal-body {
  padding: 16px;
  padding-right: 4px;
}

/deep/.ant-modal-header {
  padding: 4px 16px;
}

.changelog-modal-content {
  padding-right: 12px;
  height: calc(~'100vh - 240px');
  overflow: auto;
}
.changelog-header {
  display: block;
  margin-bottom: 2px;
  margin-top: 12px;
  .version {
    font-size: 22px;
    font-weight: bold;
    margin-right: 10px;
    color: #108ee9;
  }
  .title {
    font-size: 18px;
    margin-right: 10px;
  }
  .release-time {
    font-size: 13px;
    color: #9b9b9b;
  }
}
.changelog-content {
  padding: 0 16px;
}
</style>
